import { Fragment, useState } from "react";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addHoldingPackages, cancelTno } from '../../../actions/hpmAction';
import { getCurrentWarehouse, getUserPreference } from "../../../utilities/common";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Box, Button, Checkbox, Paper } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    }
}));

function AddHoldingPackages(props) {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    let userPref = getUserPreference();
    let warehouse = getCurrentWarehouse()['name'];
    const batchInfo = useSelector(state => state.hpmReducer.handleBlockBatch)
    const [tnos, setTnos] = useState([]);
    const [batch, setBatch] = useState('');
    const [isChecked, setIsChecked] = useState(true);
    const [partialFailMsg, setPartialFailMsg] = useState('');
    const handleTnosInput = (event) => {
        let tnosArray = event.target.value.split('\n');
        let tnosCurr = [];
        tnosArray.forEach((element) => {
            if(element) {
                tnosCurr.push(element);
            }
        });
        setTnos(tnosCurr);
    };
    const handleDetainedNotesInput = (event) => {
        props.handleDetainedResaon(event.target.value);
    };

    useEffect(() => {
        if(batchInfo) {            
            setBatch(batchInfo);
        }
    }, [batchInfo])

    return (
        <Box className={classes.root}>
            <TextField
                placeholder={t('input_tnos')}
                onChange={handleTnosInput}
                multiline
                rows={10}
                variant="outlined"
                style={{paddingBottom: 5}}
            />
            <TextField
                placeholder={t('notes')}
                label="Detained Notes"
                onChange={handleDetainedNotesInput}
                multiline
                rows={1}
                variant="outlined"
                id="addholdingpackages_detainednotes_textfield"
                style={{paddingTop: 5}}
            />
            <div style={{ display: 'flex', marginTop: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                    <Checkbox
                        checked={isChecked}
                        onClick={toggleCheckboxValue}
                    />
                    <span>{t('ignore_status')}</span>
                </div>
                <Button
                    variant="contained" 
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleAddHoldingPackages}
                >
                    {t('add')}
                </Button>
                <Button
                    variant="contained" 
                    color="#616161"
                    onClick={handleCancelHoldingPackages}
                >
                    {t('cancel')}
                </Button>
            </div>            
            <div style={{ marginTop: 20}}>
                <span>{t('detained_batch_no')}</span>
                {
                    batch && 
                    <span>{batch}</span>
                }
            </div>
        </Box>
    );

    function handleCancelHoldingPackages() {
        dispatch(cancelTno(tnos, warehouse))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('cancel_success_message_tno'), type: 'success'}))
        })
    }

    function handleAddHoldingPackages() {
        let params = {};
        params['warehouse'] = userPref.userCity;
        params['tnos'] = tnos;
        params['ignore_state'] = isChecked ? 1 : 0;
        params['notes'] = props.detainedReason;
        params['operator'] = userPref.username;
        dispatch(addHoldingPackages(params))
        .then((res) => {
            setBatch(res.add_result.block_batch);
            if(res.add_result.total_failed) {
                const failedTnos = res.add_result.failed_tnos;
                let tnos = '';
                failedTnos.map((elm) => {
                    tnos = tnos.concat(', ' + elm); 
                })
                tnos = tnos.substring(1);
                setPartialFailMsg(tnos);
                dispatch(showAlertSnackbar({message: t('partial_fail') + tnos, type: 'warning'}))
            } else {
                dispatch(showAlertSnackbar({message: t('add_success_message'), type: 'success'}))
            }           
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: t('add_fail_message'), type: 'error'}))
        })
    }
    function toggleCheckboxValue() {
        let isCheckedCurr = !isChecked;
        setIsChecked(isCheckedCurr);
    }
}

export default AddHoldingPackages;